<template>
    <div>
        <menu_c/>
        <div v-if="list_01.length">
            <a-row>
                <a-col :span="24">
                    <a-carousel autoplay>
                        <div v-for="item in list_01" :key="item.id">
                            <a-image :preview="false"
                                     :src="item.picPath"
                            />
                        </div>
                    </a-carousel>
                </a-col>
            </a-row>
        </div>

        <div v-if="list_02.length">
            <a-row>
                <a-col :span="24">
                    <a-carousel autoplay effect="fade">
                        <div v-for="item in list_02" :key="item.id">
                            <a-image :preview="false"
                                     :src="item.picPath"
                            />
                        </div>
                    </a-carousel>
                </a-col>
            </a-row>
        </div>

        <div>
            <a-row>
                <a-col :md="12" :sm="24" v-if="list_03.length">
                    <a-carousel autoplay effect="fade">
                        <div v-for="item in list_03" :key="item.id">
                            <a-image :preview="false"
                                     :src="item.picPath"
                            />
                        </div>
                    </a-carousel>
                </a-col>
                <a-col :md="12" :sm="24" v-if="list_04.length">
                    <a-carousel autoplay effect="fade">
                        <div v-for="item in list_04" :key="item.id">
                            <a-image :preview="false"
                                     :src="item.picPath"
                            />
                        </div>
                    </a-carousel>
                </a-col>
            </a-row>
        </div>

        <div>
            <a-row>
                <a-col :md="12" :sm="24" v-if="list_05.length">
                    <a-carousel autoplay effect="fade">
                        <div v-for="item in list_05" :key="item.id">
                            <a-image :preview="false"
                                     :src="item.picPath"
                            />
                        </div>
                    </a-carousel>
                </a-col>
                <a-col :md="12" :sm="24" v-if="list_06.length">
                    <a-carousel autoplay effect="fade">
                        <div v-for="item in list_06" :key="item.id">
                            <a-image :preview="false"
                                     :src="item.picPath"
                            />
                        </div>
                    </a-carousel>
                </a-col>
            </a-row>
        </div>
        <foot_c/>
    </div>
</template>

<script setup>
    import foot_c from '../../components/foot_c.vue';
    import menu_c from '../../components/menu_c.vue';
    import {onMounted, ref} from 'vue';
    import {API_sectionListBySectionTypeName} from '../../api/api.js'

    const list_01 = ref([]);
    const list_02 = ref([]);
    const list_03 = ref([]);
    const list_04 = ref([]);
    const list_05 = ref([]);
    const list_06 = ref([]);

    onMounted(() => {
        getlist();
    });

    function getlist() {
        API_sectionListBySectionTypeName("list_01", 10).then(res => {
            if (res.success && res.result.total) {
                list_01.value = res.result.list.map(item => {
                    return {
                        ...item,
                        picPath: process.env.VUE_APP_BASE_API + process.env.VUE_APP_GLOB_API_URL + `/sys/common/static/${item.pic}`
                    }
                });
            }

        });

        API_sectionListBySectionTypeName("list_02", 10).then(res => {
            if (res.success && res.result.total) {
                list_02.value = res.result.list.map(item => {
                    return {
                        ...item,
                        picPath: process.env.VUE_APP_BASE_API + process.env.VUE_APP_GLOB_API_URL + `/sys/common/static/${item.pic}`
                    }
                });
            }

        });

        API_sectionListBySectionTypeName("list_03", 10).then(res => {
            if (res.success && res.result.total) {
                list_03.value = res.result.list.map(item => {
                    return {
                        ...item,
                        picPath: process.env.VUE_APP_BASE_API + process.env.VUE_APP_GLOB_API_URL + `/sys/common/static/${item.pic}`
                    }
                });
            }

        });

        API_sectionListBySectionTypeName("list_04", 10).then(res => {
            if (res.success && res.result.total) {
                list_04.value = res.result.list.map(item => {
                    return {
                        ...item,
                        picPath: process.env.VUE_APP_BASE_API + process.env.VUE_APP_GLOB_API_URL + `/sys/common/static/${item.pic}`
                    }
                });
            }

        });

        API_sectionListBySectionTypeName("list_05", 10).then(res => {
            if (res.success && res.result.total) {
                list_05.value = res.result.list.map(item => {
                    return {
                        ...item,
                        picPath: process.env.VUE_APP_BASE_API + process.env.VUE_APP_GLOB_API_URL + `/sys/common/static/${item.pic}`
                    }
                });
            }

        });

        API_sectionListBySectionTypeName("list_06", 10).then(res => {
            if (res.success && res.result.total) {
                list_06.value = res.result.list.map(item => {
                    return {
                        ...item,
                        picPath: process.env.VUE_APP_BASE_API + process.env.VUE_APP_GLOB_API_URL + `/sys/common/static/${item.pic}`
                    }
                });
            }

        });
    }
</script>

<style scoped>
    /* For demo */
    :deep(.slick-slide) {
        text-align: center;
        max-height: 700px;
        /*line-height: 160px;*/
        /*background: darkcyan;*/
        overflow: hidden;
    }

    :deep(.slick-slide h3) {
        color: #fff;
    }

    :deep(.slick-slide img) {
        width: 100%;
        height: 100%;
        object-fit: cover; /* 类似于background-size: cover;的效果 */
    }

</style>